<template>
    <PrimaryButton
        @click="$router.push({ name: 'subscribe' })"
        icon="arrow-right"
    >Comece agora mesmo</PrimaryButton>
</template>

<script>
import PrimaryButton from '@/components/buttons/PrimaryButton'

export default {
    components: {
        PrimaryButton,
    }
  }
</script>